<template>
  <div>
    <b-card>
      <div class="row">
        <div class="col-lg-8">
          <h4>Torony daru szerkesztése</h4>
        </div>
      </div>
    </b-card>
    <form-wizard
      ref="wizard"
      color="#3e74c7"
      :title="null"
      :subtitle="null"
      :enable-finish-button="false"
      layout="vertical"
      next-button-text="Tovább"
      next-button-icon="fa fa-arrow-right"
      back-button-text="Vissza"
      finish-button-text="Frissítés"
      class="wizard-vertical mb-3"
      tabindex="3"
    >

      <!-- account datails tab -->
      <tab-content title="Torony daru adatai">
        <div class="row">
          <h5 class="col-lg-6 mb-0 pb-0">
            Torony daru adatai
          </h5>
          <div class="col-lg-6 text-right">
            <button
              class="btn btn-primary"
              @click="update"
            >
              Frissítés
            </button>
          </div>
          <b-form-group
            label="Megnevezés"
            label-for="name"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="name"
              v-model="name"
              type="text"
              placeholder="Megnevezés"
            />
          </b-form-group>
          <b-form-group
            label="Gyártó"
            label-for="brand"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="brand"
              v-model="brand"
              type="text"
              placeholder="Gyártó"
            />
          </b-form-group>
          <b-form-group
            label="Típus"
            label-for="type"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="type"
              v-model="type"
              type="text"
              placeholder="Típus"
            />
          </b-form-group>
          <b-form-group
            label="Gyártási szám"
            label-for="manufacturing_number"
            class="col-md-6 mt-1"
          >
            <b-form-input
              id="manufacturing_number"
              v-model="manufacturing_number"
              type="text"
              placeholder="Gyártási szám"
            />
          </b-form-group>
          <b-form-group
            label="Gyártási év"
            label-for="year_of_manufacture"
            class="col-md-6 mt-1"
          >
            <b-form-input
              id="year_of_manufacture"
              v-model="year_of_manufacture"
              type="number"
              placeholder="Gyártási év"
            />
          </b-form-group>
          <div class="col-md-12 mt-1">
            <p
              v-if="!is_working"
              class="text-muted"
            >
              Új naplóbejegyzés csak felszereléskor jön létre. Kérjük, használja a "Felszerelés" gombot.
            </p>
            <p
              v-else
              class="text-muted"
            >
              Új naplóbejegyzés felszereléskor jön létre; az alábbi aktív naplóhoz rögzíthet időszakos vizsgálatot.
            </p>
          </div>
          <div class="col-md-12 mt-2">
            <b-button
              v-if="!is_working"
              variant="success"
              @click="showInstallModal"
            >
              Felszerelés
            </b-button>
            <b-button
              v-if="is_working"
              variant="warning"
              @click="uninstallTowerCrane"
            >
              Leszerelés
            </b-button>
          </div>
        </div>

      </tab-content>
      <tab-content title="Vizsgálati napló">
        <div class="row mb-5">
          <h5 class="col-lg-6 mb-0 pb-0">
            Vizsgálati naplók
          </h5>
          <div class="col-lg-6 text-right">
            <button
              class="btn btn-primary"
              @click="update"
            >
              Frissítés
            </button>
          </div>
          <div class="col-md-12 mt-1">
            <p
              v-if="!is_working"
              class="text-muted"
            >
              Új naplóbejegyzés csak felszereléskor jön létre. Kérjük, használja a "Felszerelés" gombot.
            </p>
            <p
              v-else
              class="text-muted"
            >
              Új naplóbejegyzés felszereléskor jön létre; az alábbi aktív naplóhoz rögzíthet időszakos vizsgálatot.
            </p>
          </div>
          <div class="col-lg-12 mt-3">
            <h5>Meglévő vizsgálatok</h5>
            <vue-good-table
              :columns="logColumns"
              :rows="logs"
              :pagination-options="{
                enabled: true,
                perPage: 10
              }"
            >
              <template
                slot="table-row"
                slot-scope="props"
              >
                <span v-if="props.column.field === 'place_of_installation'">
                  {{ getProjectName(props.row.place_of_installation) }}
                </span>
                <span v-else-if="props.column.field === 'inspection_type'">
                  <span v-if="props.row.periodic_inspection && props.row.periodic_inspection.length > 0">
                    {{ getLatestInspection(props.row.periodic_inspection).type }}
                  </span>
                  <span v-else>-</span>
                </span>
                <span v-else-if="props.column.field === 'inspection_date'">
                  <span
                    v-if="props.row.periodic_inspection && props.row.periodic_inspection.length > 0"
                    @click="showLogDetailsModal(props.row)"
                  >
                    {{ getLatestInspection(props.row.periodic_inspection).review_date }}
                  </span>
                  <span v-else>-</span>
                </span>
                <span v-else-if="props.column.field === 'next_inspection'">
                  {{ getNextInspectionDate(props.row) }}
                </span>
                <span v-else-if="props.column.field === 'action'">
                  <div class="d-flex flex-wrap">
                    <b-button
                      variant="outline-danger"
                      size="sm"
                      class="mr-1 mb-1"
                      @click="removeLog(props.row.id)"
                    >
                      Törlés
                    </b-button>
                    <b-button
                      v-if="props.row.is_active && props.row.id === latestActiveLogId"
                      variant="outline-primary"
                      size="sm"
                      class="mb-1"
                      @click="showAddInspectionModal(props.row.id)"
                    >
                      Vizsgálat hozzáadása
                    </b-button>
                  </div>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </tab-content>
    </form-wizard>

    <!-- Felszerelési Modal -->
    <b-modal
      id="install-modal"
      title="Torony daru felszerelése"
      hide-footer
    >
      <div class="row">
        <b-form-group
          label="Felszerelés dátuma"
          label-for="install_date_of_installation"
          class="col-md-12 mt-1"
        >
          <b-form-input
            id="install_date_of_installation"
            v-model="install_date_of_installation"
            type="date"
            placeholder="Felszerelés dátuma"
            required
          />
        </b-form-group>
        <b-form-group
          label="Felszerelés helye (Projekt)"
          label-for="install_place_of_installation"
          class="col-md-12 mt-1"
        >
          <b-form-select
            id="install_place_of_installation"
            v-model="install_place_of_installation"
            :options="projectOptions"
            text-field="text"
            value-field="value"
            required
            @change="onProjectChange"
          >
            <template #first>
              <b-form-select-option
                :value="null"
                disabled
              >
                -- Válasszon projektet --
              </b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
        <b-form-group
          label="Üzemeltető cég neve"
          label-for="install_operating_company_name"
          class="col-md-12 mt-1"
        >
          <b-form-input
            id="install_operating_company_name"
            v-model="install_operating_company_name"
            type="text"
            placeholder="Üzemeltető cég neve"
            disabled
          />
        </b-form-group>
        <b-form-group
          label="Építmény"
          label-for="install_building"
          class="col-md-12 mt-1"
        >
          <b-form-input
            id="install_building"
            v-model="install_building"
            type="text"
            placeholder="Építmény"
            required
          />
        </b-form-group>
        <div class="col-md-12 mt-2">
          <b-button
            variant="success"
            @click="installTowerCrane"
          >
            Felszerelés
          </b-button>
          <b-button
            variant="secondary"
            class="ml-2"
            @click="$bvModal.hide('install-modal')"
          >
            Mégse
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Add periodic inspection modal -->
    <b-modal
      id="add-inspection-modal"
      title="Vizsgálat hozzáadása"
      hide-footer
    >
      <div class="row">
        <b-form-group
          label="Vizsgálat dátuma"
          label-for="add_inspection_review_date"
          class="col-md-12 mt-1"
        >
          <b-form-input
            id="add_inspection_review_date"
            v-model="add_inspection_review_date"
            type="date"
            required
          />
        </b-form-group>
        <div class="col-md-12 mt-2">
          <b-button
            variant="success"
            @click="addPeriodicInspection"
          >
            Rögzít
          </b-button>
          <b-button
            variant="secondary"
            class="ml-2"
            @click="$bvModal.hide('add-inspection-modal')"
          >
            Mégse
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Log Details Modal -->
    <b-modal
      id="log-details-modal"
      title="Felszerelési napló részletei"
      size="lg"
      hide-footer
    >
      <b-row class="my-1 pl-1 pr-1">
        <b-col
          lg="12"
          class="mt-1"
        >
          <b>Felszerelési információk</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Felszerelés dátuma: <b>{{ selectedLogData.date_of_installation }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Helyszín: <b>{{ getProjectName(selectedLogData.place_of_installation) }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Üzemeltető cég: <b>{{ selectedLogData.operating_company_name }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Építmény: <b>{{ selectedLogData.building }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Leszerelés dátuma: <b>{{ selectedLogData.uninstallation_date || 'Aktív' }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Állapot:
          <b-badge
            :variant="selectedLogData.is_active ? 'success' : 'secondary'"
            style="color: white !important;"
          >
            {{ selectedLogData.is_active ? 'Aktív' : 'Leszerelve' }}
          </b-badge>
        </b-col>
        <b-col
          lg="12"
          class="mt-3"
        >
          <hr>
          <b>Időszakos vizsgálatok ({{ getInspectionCount(selectedLogData) }} db)</b>
        </b-col>
        <b-col v-if="!selectedLogData.periodic_inspection || selectedLogData.periodic_inspection.length === 0">
          <p class="text-muted">
            Még nincs rögzített vizsgálat.
          </p>
        </b-col>
        <b-col v-else>
          <table class="table table-responsive">
            <tr>
              <th><b>Sorszám</b></th>
              <th><b>Vizsgálat típusa</b></th>
              <th><b>Vizsgálat dátuma</b></th>
              <th><b>Rögzítés időpontja</b></th>
            </tr>
            <tr
              v-for="(inspection, index) in selectedLogData.periodic_inspection"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>
                <b-badge
                  variant="info"
                  style="color: white !important;"
                >
                  {{ inspection.type }}
                </b-badge>
              </td>
              <td>{{ inspection.review_date }}</td>
              <td>{{ inspection.created_at || '-' }}</td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BCard,
  BButton,
  BModal,
  BBadge,
  BRow,
  BCol,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import axios from 'axios'

export default {
  components: {
    FormWizard,
    TabContent,
    BCard,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BButton,
    BModal,
    BBadge,
    BRow,
    BCol,
    VueGoodTable,
    FeatherIcon,
  },
  data() {
    return {
      name: '',
      brand: '',
      type: '',
      manufacturing_number: '',
      year_of_manufacture: '',
      is_working: false,
      log_date_of_installation: '',
      log_place_of_installation: '',
      log_operating_company_name: '',
      log_building: '',
      log_periodic_inspection: '',
      install_date_of_installation: '',
      install_place_of_installation: '',
      install_operating_company_name: '',
      install_building: '',
      logs: [],
      selectedLogData: {},
      add_inspection_review_date: '',
      add_inspection_log_id: null,
      projects: [],
      logColumns: [
        {
          label: 'Felszerelés dátuma',
          field: 'date_of_installation',
        },
        {
          label: 'Felszerelés helye',
          field: 'place_of_installation',
        },
        {
          label: 'Üzemeltető cég',
          field: 'operating_company_name',
        },
        {
          label: 'Építmény',
          field: 'building',
        },
        {
          label: 'Vizsgálat típusa',
          field: 'inspection_type',
        },
        {
          label: 'Vizsgálat dátuma',
          field: 'inspection_date',
        },
        {
          label: 'Következő vizsgálat',
          field: 'next_inspection',
        },
        {
          label: 'Műveletek',
          field: 'action',
        },
      ],
    }
  },
  computed: {
    latestActiveLogId() {
      const active = this.logs.find(l => l.is_active)
      return active ? active.id : null
    },
    projectOptions() {
      return this.projects.map(project => {
        const workPrefix = project.work_number ? project.work_number.substring(0, 2) : ''
        let operatorCompany = ''
        if (workPrefix === 'ME') {
          operatorCompany = 'Monolit Épszer Kft'
        } else if (workPrefix === 'MP') {
          operatorCompany = 'Monolit Profi Kft'
        }
        return {
          value: project.id,
          text: project.name,
          work_number: project.work_number,
          operator_company: operatorCompany,
        }
      })
    },
  },
  mounted() {
    this.getTowerCrane()
    this.getLogs()
    this.getProjects()
    this.$refs.wizard.nextTab()
    this.$refs.wizard.nextTab()
    this.$refs.wizard.nextTab()
    this.$refs.wizard.prevTab()
    this.$refs.wizard.prevTab()
    this.$refs.wizard.prevTab()
  },
  methods: {
    getProjects() {
      axios({
        method: 'get',
        url: 'project/list',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.projects = response.data
      })
    },
    onProjectChange(projectId) {
      if (!projectId) {
        this.install_operating_company_name = ''
        return
      }
      const selectedProject = this.projectOptions.find(p => p.value === projectId)
      if (selectedProject && selectedProject.operator_company) {
        this.install_operating_company_name = selectedProject.operator_company
      } else {
        this.install_operating_company_name = ''
      }
    },
    getProjectName(projectId) {
      if (!projectId) return '-'
      const project = this.projects.find(p => p.id == projectId)
      return project ? project.name : projectId
    },
    showInstallModal() {
      this.$bvModal.show('install-modal')
    },
    installTowerCrane() {
      if (!this.install_date_of_installation || !this.install_place_of_installation
          || !this.install_operating_company_name || !this.install_building) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiányzó adatok!',
            text: 'Kérjük töltse ki az összes kötelező mezőt.',
            variant: 'danger',
          },
        })
        return
      }

      axios({
        method: 'post',
        url: `tower-crane/${this.$route.params.id}/install`,
        data: {
          date_of_installation: this.install_date_of_installation,
          place_of_installation: this.install_place_of_installation,
          operating_company_name: this.install_operating_company_name,
          building: this.install_building,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres felszerelés!',
            text: 'A torony daru sikeresen felszerelve.',
            variant: 'success',
          },
        })
        this.$bvModal.hide('install-modal')
        this.install_date_of_installation = ''
        this.install_place_of_installation = ''
        this.install_operating_company_name = ''
        this.install_building = ''
        this.getTowerCrane()
        this.getLogs()
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba történt!',
            text: 'A torony daru felszerelése sikertelen.',
            variant: 'danger',
          },
        })
      })
    },
    uninstallTowerCrane() {
      axios({
        method: 'post',
        url: `tower-crane/${this.$route.params.id}/uninstall`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres leszerelés!',
            text: 'A torony daru sikeresen leszerelve.',
            variant: 'success',
          },
        })
        this.getTowerCrane()
        this.getLogs()
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba történt!',
            text: 'A torony daru leszerelése sikertelen.',
            variant: 'danger',
          },
        })
      })
    },
    getLogs() {
      axios({
        method: 'get',
        url: `tower-crane/${this.$route.params.id}/log/list`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.logs = response.data
      })
    },

    // Helper method to get the latest inspection based on array position
    getLatestInspection(periodicInspections) {
      if (!periodicInspections || periodicInspections.length === 0) {
        return { type: '-', review_date: '-' }
      }

      // Simply return the last element of the array
      return periodicInspections[periodicInspections.length - 1]
    },

    // Helper method to calculate next inspection date
    getNextInspectionDate(logRow) {
      // If not active, show "Leszerelve"
      if (!logRow.is_active) {
        return 'Leszerelve'
      }

      let baseDate

      // If there are inspections, use the latest inspection date
      if (logRow.periodic_inspection && logRow.periodic_inspection.length > 0) {
        const latestInspection = this.getLatestInspection(logRow.periodic_inspection)
        baseDate = new Date(latestInspection.review_date)
      } else {
        // If no inspections, use the installation date
        baseDate = new Date(logRow.date_of_installation)
      }

      // Add 8 months to the base date
      const nextDate = new Date(baseDate)
      nextDate.setMonth(nextDate.getMonth() + 8)

      // Format as YYYY-MM-DD
      return nextDate.toISOString().split('T')[0]
    },

    // open modal to add a single periodic inspection (review_date) to the latest active log
    showAddInspectionModal(logId) {
      this.add_inspection_log_id = logId
      this.add_inspection_review_date = ''
      this.$bvModal.show('add-inspection-modal')
    },

    addPeriodicInspection() {
      if (!this.add_inspection_review_date || !this.add_inspection_log_id) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiányzó adat!',
            text: 'Kérjük adja meg a vizsgálat dátumát.',
            variant: 'danger',
          },
        })
        return
      }

      axios({
        method: 'post',
        url: `tower-crane/log/${this.add_inspection_log_id}/add-periodic-inspection`,
        data: {
          review_date: this.add_inspection_review_date,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres rögzítés!',
            text: 'A vizsgálat sikeresen hozzáadva a naplóhoz.',
            variant: 'success',
          },
        })
        this.$bvModal.hide('add-inspection-modal')
        this.add_inspection_review_date = ''
        this.add_inspection_log_id = null
        this.getLogs()
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba történt!',
            text: 'A vizsgálat rögzítése sikertelen.',
            variant: 'danger',
          },
        })
      })
    },
    removeLog(index) {
      axios({
        method: 'delete',
        url: `tower-crane/log/delete/${index}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.getLogs()
      })
    },
    getTowerCrane() {
      axios({
        method: 'get',
        url: `tower-crane/list/${this.$route.params.id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        this.name = res.data.name
        this.brand = res.data.brand
        this.type = res.data.type
        this.manufacturing_number = res.data.manufacturing_number
        this.year_of_manufacture = res.data.year_of_manufacture
        this.is_working = res.data.is_working
      })
    },
    showLogDetailsModal(logData) {
      this.selectedLogData = logData
      this.$bvModal.show('log-details-modal')
    },
    getInspectionCount(logData) {
      if (!logData.periodic_inspection || !Array.isArray(logData.periodic_inspection)) {
        return 0
      }
      return logData.periodic_inspection.length
    },
    update() {
      axios({
        method: 'put',
        url: `tower-crane/update/${this.$route.params.id}`,
        data: {
          name: this.name,
          brand: this.brand,
          type: this.type,
          manufacturing_number: this.manufacturing_number,
          year_of_manufacture: this.year_of_manufacture,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres frissítés!',
            text: 'A torony daru sikeresen frissítve.',
            variant: 'success',
          },
        })
        this.$router.push('/tower-cranes/list')
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba történt!',
            text: 'A torony daru frissítése sikertelen.',
            variant: 'danger',
          },
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
